<template>
  <div class="app-pallets">
    <v-header v-bind:user="user" />
    <div class="pallet-content" v-if="loaded">
      <div class="pallet-top">
        <span class="pallet-header">Paletė {{pallet}}</span>
        <pallet-top
          id="pallet-top"
          :pallet="pallet"
          :divider="dividerTop"
          :settings="settings"
          :showTexts="true"
        />
      </div>
      <div class="pallet-side">
        <pallet-side id="pallet-side" :pallet="pallet" :divider="dividerSide" :settings="settings" />
      </div>
      <div id="pallet-3d" class="pallet-3d">
        <PalletViewing v-if="pallet" :pallet="pallet" />
      </div>
      <div class="pallet-products-list">
        <div class="products-list" v-for="(product, i) in pallet.products" :key="i">
          <span>{{ product.getTextOnPallet(pallet, this) }}</span>
        </div>
      </div>
      <div class="pallet-photos">
        <div class="photo-buttons">
          <div class="add-button" @click="addPhoto" v-if="user.type != 6">
            <v-icon v-tooltip="$t('pallet_info_page.add_photo')" color="white" large>camera</v-icon>
            <input
              style="display:none"
              type="file"
              id="files"
              accept="image/x-png, image/gif, image/jpeg"
              ref="files"
              multiple
              @change="handleFilesUpload"
            />
          </div>
        </div>
        <v-card class="pallet-card" v-for="(photo, i) in pallet.attachments" :key="i">
          <div class="pallet-header">{{photo.created_at}}</div>
          <div class="pallet-photo container portrait">
            <img :src="photo.location" class="w3-round" alt="Norway" />
          </div>
          <div class="download-button" @click="download(photo)" v-if="user.type != 6">
            <v-icon color="white" large>vertical_align_bottom</v-icon>
          </div>
          <div class="delete-button" @click="deletePhoto(photo)" v-if="user.type != 6">
            <v-icon color="white" large>delete</v-icon>
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import Pallet from "@/models/Pallet.js";
import Attachment from "@/models/Attachment.js";
import Helper from "@/models/Helper.js";
import VHeader from "@/components/header";
import User from "@/models/User.js";
import PalletTop from "@/components/user/pallets/PalletTop.vue";
import PalletSide from "@/components/user/pallets/PalletSide.vue";
import PalletViewing from "@/components/palleting/PalletViewing.vue";
export default {
  data() {
    return {
      user: new User(this.$session.get("user")),
      loaded: false,
      settings: {
        palletHeight: 120,
        palletWeight: 2000,
        spacingBetween: 0,
        spacingEnds: 0,
        spacingSides: 0,
      },
      palletId: this.$route.params.id,
      dividerTop: 6,
      dividerSide: 9,
      files: "",
    };
  },
  mounted() {
    this.initialize();
    window.addEventListener("resize", () => {
      this.handleResize();
    });
    this.checkUser();
  },
  methods: {
    async initialize() {
      this.dividerTop = 6;
      this.dividerSide = 9;
      const pallet = await Pallet.loadPallet(this.palletId, {
        with_products: 1,
        with_order: 1,
        with_photos: 1,
      });
      this.pallet = pallet;
      this.loaded = true;
      await Helper.timeout(50);
      this.handleResize();
    },
    checkUser() {
      if (this.user.company_id == 9) {
        this.$session.destroy();
        this.$router.push("/login").catch(() => {});
      }
    },
    handleResize() {
      if (
        this.pallet != null &&
        document.getElementById("pallet-top") != null
      ) {
        if (this.pallet.length == 0 || this.pallet.width == 0) {
          return 0;
        }
        const dividerTop =
          this.pallet.length /
          (document.getElementById("pallet-top").offsetWidth - 50);
        const dividerSide = this.pallet.getHeight() / 200;
        this.dividerTop = dividerTop <= 3 ? 3 : dividerTop;
        this.dividerSide = dividerSide <= 10 ? 10 : dividerSide;
      }
    },

    download(photo) {
      window.open(photo.location, "_blank");
    },

    async deletePhoto(photo) {
      const confirmed = confirm(
        this.$t("pallet_info_page.delete_photo_prompt")
      );
      if (!confirmed) return;
      await photo.remove();
      this.initialize();
    },

    addPhoto() {
      const photoInput = document.getElementById("files");
      photoInput.click();
    },

    async handleFilesUpload() {
      this.files = this.$refs.files.files;
      if (this.files) {
        await Attachment.uploadFiles(this.palletId, "pallets", this.files);
        this.files = "";
        this.initialize();
      }
    },
  },
  components: {
    VHeader,
    PalletTop,
    PalletSide,
    PalletViewing,
  },
};
</script>

<style scoped>
.pallet-header {
  font-size: 16px;
  font-weight: 800;
}
.pallet-content {
  position: absolute;
  width: 100%;
  height: calc(100% - 70px);
}
.pallet-top {
  position: absolute;
  width: 30%;
  height: 50%;
  padding-left: 20px;
  padding-top: 80px;
}
.pallet-side {
  position: absolute;
  top: calc(50%);
  width: 30%;
  height: calc(50%);
  padding-left: 20px;
  padding-top: 20px;
}
.pallet-3d {
  position: absolute;
  left: 30%;
  width: 30%;
  height: 50%;
}
.pallet-products-list {
  position: absolute;
  top: calc(50%);
  left: 30%;
  width: 30%;
  height: calc(50%);
  overflow-y: auto;
}
.pallet-photos {
  position: absolute;
  width: 40%;
  height: calc(100%);
  background: lavender;
  left: 60%;
  overflow-y: auto;
}
.pallet-products-list::-webkit-scrollbar {
  width: 10px;
}

.pallet-products-list::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.pallet-products-list::-webkit-scrollbar-thumb {
  background: rgba(117, 121, 129, 0.952);
}
.pallet-photos::-webkit-scrollbar {
  width: 10px;
}

.pallet-photos::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.pallet-photos::-webkit-scrollbar-thumb {
  background: rgba(117, 121, 129, 0.952);
}
.products-list {
  font-weight: 600;
  font-size: 16px;
}
.pallet-card {
  position: relative;
  display: table;
  width: calc(100% - 50px);
  min-height: 600px;
  margin: 0 auto;
  background: pink;
  margin-top: 20px;
}
.pallet-header {
  position: relative;
  padding-left: 10px;
  padding-top: 2px;
  width: 100%;
  height: 25px;
  font-size: 14px;
  font-weight: 500;
}
.container {
  height: 500px;
  width: calc(100% - 100px);
  float: left;
  overflow: hidden;
  margin: 20px;
}
.container img {
  display: block;
}

.portrait img {
  width: 100%;
}
.landscape img {
  height: 100%;
}
.download-button {
  cursor: pointer;
  position: absolute;
  background: #42a5f5;
  top: 0;
  right: 0px;
  width: 50px;
  height: 40px;
  text-align: center;
  vertical-align: middle;
}
.delete-button {
  cursor: pointer;
  position: absolute;
  background: #ef5350;
  top: 40px;
  right: 0px;
  width: 50px;
  height: 40px;
  text-align: center;
  vertical-align: middle;
}
.add-button {
  cursor: pointer;
  background: #66bb6a;
  width: 50px;
  height: 40px;
  text-align: center;
  vertical-align: middle;
}
.photo-buttons {
  height: 40px;
  position: relative;
  background: white;
}
</style>